import * as actionTypes from './actionTypes';
import { TypePublicationModel } from '@app/src/views/StepTwo/channelPublication/models/typePublication';

interface State {
  data: TypePublicationModel[];
  isFetching: boolean;
  error: boolean;
  selected: TypePublicationModel | {};
}

const initialState: State = {
  data: [],
  isFetching: false,
  error: false,
  selected: null
}

export const typePublication = (state = initialState, action): State => {
  switch (action.type) {
    case actionTypes.FETCH_TYPE_PUBLICATION_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case actionTypes.FETCH_TYPE_PUBLICATION_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: true
      }
    case actionTypes.FETCH_TYPE_PUBLICATION_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: false,
        data: action.data
      }
    case actionTypes.SET_TYPE_PUBLICATION_SELECTED:
      return {
        ...state,
        selected: action.value
      }
    case actionTypes.CLEAR_TYPE_PUBLICATION_ALL:
      return {
        isFetching: false,
        error: false,
        data: [],
        selected: {}
      }
    default:
      return state;
  }
}
